import React from 'react';
import { Outlet, Link, useNavigate, useLocation } from 'react-router-dom';
import { LayoutDashboard, Plus, LogOut } from 'lucide-react';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_pr-platform-4/artifacts/fou5e3pi_Untitled%20design.png';

const AdminLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    localStorage.removeItem('adminToken');
    navigate('/admin/login');
  };

  const navigation = [
    { name: 'Dashboard', href: '/admin/dashboard', icon: LayoutDashboard },
    { name: 'New Press Release', href: '/admin/press-releases/new', icon: Plus },
  ];

  const isActive = (href) => location.pathname === href;

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white border-b border-gray-200 shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-24">
            <Link to="/admin/dashboard" className="flex items-center space-x-4" data-testid="admin-logo-link">
              <img 
                src={LOGO_URL} 
                alt="Ixoraly Logo" 
                className="h-14 w-auto"
              />
              <div className="flex items-center space-x-3">
                <span className="text-2xl font-bold text-gray-900">Ixoraly</span>
                <span className="text-xs bg-coral-100 text-coral-700 px-3 py-1 rounded-full font-medium">Admin</span>
              </div>
            </Link>

            <div className="flex items-center space-x-4">
              <Link
                to="/"
                data-testid="view-site-button"
                className="text-sm font-medium text-gray-600 hover:text-gray-900"
              >
                View Site
              </Link>
              <button
                onClick={handleLogout}
                data-testid="logout-button"
                className="flex items-center space-x-2 px-4 py-2 text-sm font-medium text-white bg-coral-600 rounded-lg hover:bg-coral-700 transition-colors"
              >
                <LogOut size={16} />
                <span>Logout</span>
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Navigation */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <nav className="flex space-x-4 mb-6">
          {navigation.map((item) => {
            const Icon = item.icon;
            return (
              <Link
                key={item.name}
                to={item.href}
                data-testid={`admin-nav-${item.name.toLowerCase().replace(/\s+/g, '-')}`}
                className={`flex items-center space-x-2 px-4 py-2 rounded-lg font-medium text-sm transition-colors ${
                  isActive(item.href)
                    ? 'bg-coral-600 text-white'
                    : 'bg-white text-gray-700 hover:bg-gray-100'
                }`}
              >
                <Icon size={18} />
                <span>{item.name}</span>
              </Link>
            );
          })}
        </nav>

        {/* Content */}
        <Outlet />
      </div>
    </div>
  );
};

export default AdminLayout;